/**
 * Vehicle type values
 */
export enum VehicleTypeEnum {
	MOTORBIKE = 'motorbike',
	CAR = 'car',
	BICYCLE = 'bicycle',
	ATV_BUGGY = 'atv_buggy',
}
